import React, { useEffect }  from 'react';
import WOW from "wowjs";
import { Link } from 'react-router-dom';

function ServiceOne(){
  useEffect(() => {
    const wow = new WOW.WOW({
      live: false, // This disables continuous scanning for new elements
    });
    wow.init();
  }, []);
  
    return (
      <div>
        <div>
          <div className="tmp-services-area services-style--1 mt-5 background-image-services bg_image tmp-section-gap">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-head">
                    <div className="section-sub-title center-title">
                      <img
                        alt="Business_Consulting_services"
                        src="assets/images/services/section-custom-menubar.png "
                      />
                      <span className="text-dark">OUR SERVICES</span>
                    </div>
                    <h2 className="title split-collab">
                      Our Provided Services
                    </h2>
                  </div>
                </div>
              </div>
              <div className="row g-5">
                <div
                  className="col-lg-4 col-md-6 col-sm-12 col-12 wow fadeInLeft"
                  data-wow-duration=".8s"
                  data-wow-delay=".1s"
                >
                  <div className="single-services service-style-one">
                    <div className="services-inner  with-shadow card-bg-color">
                      <div className="thumbnail">
                        <img
                          alt="Business consulting services"
                          src="assets/images/services/business-formation.png"
                          style={{ width: "80px", height: "80px" }}
                        />
                      </div>
                      <div className="services-content">
                        <Link to={"/Business-Formation"}>
                          <h5 className="title">Business Formation</h5>
                        </Link>
                        <p className="desctiption">
                          Let us help turn your vision to reality. We are proud
                          to offer personalized business formation services
                          tailored to meet your unique needs.
                        </p>
                        <Link
                          className="icon angle-roted"
                          to={"/Business-Formation"}
                        >
                          <i className="fa-solid fa-arrow-right" />
                        </Link>
                      </div>
                      <div className="number">
                        <img
                          alt="Business Consulting number"
                          src="assets/images/services/icon-01.png"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6 col-sm-12 col-12 wow fadeInLeft"
                  data-wow-duration=".8s"
                  data-wow-delay=".2s"
                >
                  <div className="single-services service-style-one">
                    <div className="services-inner  with-shadow card-bg-color">
                      <div className="thumbnail">
                        <img
                          alt="Business consulting services"
                          src="assets/images/services/services-icon-2.png"
                        />
                      </div>
                      <div className="services-content">
                        <Link to={"/payroll-management"}>
                          <h5 className="title">Payroll Management</h5>
                        </Link>
                        <p className="desctiption">
                          Partner with us to streamline your payroll operations
                          and ensure your employees are paid accurately and on
                          time.
                        </p>
                        <Link
                          className="icon angle-roted"
                          to={"/payroll-management"}
                        >
                          <i className="fa-solid fa-arrow-right" />
                        </Link>
                      </div>
                      <div className="number">
                        <img
                          alt="Business Consulting number"
                          src="assets/images/services/icon-02.png"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6 col-sm-12 col-12 wow fadeInLeft"
                  data-wow-duration=".8s"
                  data-wow-delay=".3s"
                >
                  <div className="single-services service-style-one">
                    <div className="services-inner  with-shadow card-bg-color">
                      <div className="thumbnail">
                        <img
                          alt="Business consulting services"
                          src="assets/images/services/services-icon-3.png"
                        />
                      </div>
                      <div className="services-content">
                        <Link to={"/book-keeping"}>
                          <h5 className="title">Book keeping</h5>
                        </Link>
                        <p className="desctiption">
                          Let us take the burden of managing your finances off
                          your shoulders by our personalized, reliable
                          bookkeeping services.
                        </p>
                        <Link
                          className="icon angle-roted"
                          to={"/book-keeping"}
                        >
                          <i className="fa-solid fa-arrow-right" />
                        </Link>
                      </div>
                      <div className="number">
                        <img
                          alt="Business Consulting number"
                          src="assets/images/services/icon-03.png"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="col-lg-4 col-md-6 col-sm-12 col-12 wow fadeInLeft"
                  data-wow-duration=".8s"
                  data-wow-delay=".1s"
                >
                  <div className="single-services service-style-one">
                    <div className="services-inner  with-shadow card-bg-color">
                      <div className="thumbnail">
                        <img
                          alt="Business consulting services"
                          src="assets/images/services/tax.png"
                          style={{ width: "80px", height: "80px" }}
                        />
                      </div>
                      <div className="services-content">
                        <Link to={"/tax"}>
                          <h5 className="title">Tax</h5>
                        </Link>
                        <p className="desctiption">
                          Take the stress out of tax season with our filing services keeping clients ready, confident, and connected.
                        </p>
                        <Link
                          className="icon angle-roted"
                          to={"/tax"}
                        >
                          <i className="fa-solid fa-arrow-right" />
                        </Link>
                      </div>
                      <div className="number">
                        <img
                          alt="Business Consulting number"
                          src="assets/images/services/04.png"
                          style={{ width: "92px", height: "106px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="col-lg-4 col-md-6 col-sm-12 col-12 wow fadeInLeft"
                  data-wow-duration=".8s"
                  data-wow-delay=".1s"
                >
                  <div className="single-services service-style-one">
                    <div className="services-inner  with-shadow card-bg-color">
                      <div className="thumbnail">
                        <img
                          alt="Business consulting services"
                          src="assets/images/services/business-consultation.png"
                          style={{ width: "80px", height: "80px" }}
                        />
                      </div>
                      <div className="services-content">
                        <Link to={"/business-consultation"}>
                          <h5 className="title">Business Consultations</h5>
                        </Link>
                        <p className="desctiption">
                       Our consultation services offer expert guidance and practical solutions to streamline operations, enhance efficiency, and drive growth.
                        </p>
                        <Link
                          className="icon angle-roted"
                          to={"/business-consultation"}
                        >
                          <i className="fa-solid fa-arrow-right" />
                        </Link>
                      </div>
                      <div className="number">
                        <img
                          alt="Business Consulting number"
                          src="assets/images/services/05.png"
                          style={{ width: "92px", height: "106px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>


                 <div
                  className="col-lg-4 col-md-6 col-sm-12 col-12 wow fadeInLeft"
                  data-wow-duration=".8s"
                  data-wow-delay=".1s"
                >
                  <div className="single-services service-style-one">
                    <div className="services-inner  with-shadow card-bg-color">
                      <div className="thumbnail">
                        <img
                          alt="Business consulting services"
                          src="assets/images/services/business-consultation.png"
                          style={{ width: "80px", height: "80px" }}
                        />
                      </div>
                      <div className="services-content">
                        <Link to={"/business-consultation"}>
                          <h5 className="title">Business Consultations</h5>
                        </Link>
                        <p className="desctiption">
                        Our consultation services offer expert guidance and practical solutions to streamline operations, enhance efficiency, and drive growth.
                        </p>
                        <Link
                          className="icon angle-roted"
                          to={"/business-consultation"}
                        >
                          <i className="fa-solid fa-arrow-right" />
                        </Link>
                      </div>
                      <div className="number">
                        <img
                          alt="Business Consulting number"
                          src="assets/images/services/05.png"
                          style={{ width: "92px", height: "106px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>



              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="services-bottom">
                    <div className="services-bottom-inner">
                      <p className="description" style={{ width: "60%" }}>
                        Get in touch today to discuss how our expert consultants
                        can provide tailored solutions to drive your business
                        forward. Our dedicated team is ready to assist with any
                        inquiries and ensure your consulting needs are met with
                        precision.
                      </p>
                      <p className="description">
                        Want to learn more About us?
                        <button className="btn-simple"><Link to="/about">Click here</Link></button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}


export default ServiceOne





